import { combineReducers } from "@reduxjs/toolkit";
import users from "../reducers/user/user-reducer";
import publicSlice from "../reducers/public/public-Slice";
import betweenAccountSlice from "../reducers/between-accounts/between-account-Slice";
import withdraw from "../reducers/withdraw/withdraw.slice";

const rootReducer = combineReducers({
  users: users,
  public: publicSlice,
  transferBetweenAccounts: betweenAccountSlice,
  withdraw: withdraw,
});

export default rootReducer;
